import { Icon } from 'components/atoms/Icon'
import type { IconName } from 'components/atoms/Icon/iconMap'

type CardHeaderProps = {
  title?: string
  image?: IconName
  mainClass: string
}

export const CardHeader = ({ title, image, mainClass }: CardHeaderProps) => {
  if (!title && !image) return null

  return (
    <div className={`${mainClass}__head`}>
      {image && (
        <div className={`${mainClass}__icon-wrap`}>
          <Icon name={image} />
        </div>
      )}
      {title && <h4 className={`${mainClass}__title`}>{title}</h4>}
    </div>
  )
}
